import { createContext } from 'react';

import { DateRangeContextValue } from './DateRangeProvider.types';

export const DateRangeContext = createContext<DateRangeContextValue | undefined>(undefined);
